import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 2E5B9249-0FFB-48D0-8A61-2019FD9ED32F
 * name caravan
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/caravan.svg
 * tags
 * - Transportation + Road 
 * - Home Automation 
 * - Automotive 
 */
export const CaravanIcon = createSvgIcon(<><path d="M5,7A2,2 0 0,0 3,9V15A2,2 0 0,0 5,17H7A3,3 0 0,0 10,20A3,3 0 0,0 13,17H21V15H19V9A2,2 0 0,0 17,7H5M5,9H10V12H5V9M13,9H17V12H13V9M10,16A1,1 0 0,1 11,17A1,1 0 0,1 10,18A1,1 0 0,1 9,17A1,1 0 0,1 10,16Z" /></>, 'CaravanIcon');
export default CaravanIcon